import { render, staticRenderFns } from "./ModalAddController.vue?vue&type=template&id=126a562d&scoped=true&"
import script from "./ModalAddController.vue?vue&type=script&lang=js&"
export * from "./ModalAddController.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddController.vue?vue&type=style&index=0&id=126a562d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a562d",
  null
  
)

export default component.exports